<!-- Breadcrumb Section -->
<div class="bg-header" *ngIf="configurationService.isTabletOrLarger$ | async">
  <div class="container-header">
    <div class="h2" routeDirective>
      <a
        [routerLink]="[appRoutesNS.Competitions.COMPETITIONS]"
        class="px-2 d-inline-block"
        ><i
          class="fa fa-arrow-left back-arrow"
          role="img"
          attr.aria-label="{{ 'general.back' | translate }}"
        ></i
      ></a>
      {{ 'general.back' | translate }}
    </div>
  </div>
</div>
<!-- End Breadcrumb Section -->

<div class="container-lg main-container">
  <!-- Card -->
  <section class="card mb-3 mb-lg-4 border rounded-3">
    <!-- Body -->
    <div class="card-body card-body-height">
      <ng-container>
        <label class="form-label" id="poolLabel">
          {{ 'competitionModule.selectPool' | translate }}
        </label>

        <div class="mb-4">
          <div
            class="spinner-border"
            role="status"
            *ngIf="isLoading$ | async"
            attr.aria-label="{{ 'wcag.loading' | translate }}"
          ></div>
          <div *ngIf="!(isLoading$ | async)">
            <select
              class="form-select"
              [(ngModel)]="selectedPool"
              (change)="onSelect($event.target.value, 'pool')"
              aria-labelledby="poolLabel"
            >
              <option [ngValue]="null" selected>
                {{ 'general.select' | translate }}
              </option>
              <option
                *ngFor="let pool of competitionPools$ | async"
                [ngValue]="pool.name"
              >
                {{ pool.name }}
              </option>
            </select>
          </div>
        </div>
      </ng-container>
      <!--- Pool Selector-->

      <!-- Nav -->
      <nav
        attr.aria-label="{{ 'wcag.competitionMenu' | translate }}"
        role="tablist"
      >
        <ul class="nav nav-tabs align-items-center ps-2">
          <li class="nav-item">
            <a
              class="nav-link"
              (click)="selectedTab = 'matches'"
              (keyup.enter)="selectedTab = 'matches'"
              href="javascript:;"
              [ngClass]="{
                active: selectedTab == 'matches'
              }"
              role="tab"
              [attr.aria-selected]="selectedTab == 'matches' ? 'true' : 'false'"
            >
              {{ 'competitionModule.matches' | translate }}
            </a>
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              (click)="selectedTab = 'results'"
              (keyup.enter)="selectedTab = 'results'"
              [ngClass]="{ active: selectedTab == 'results' }"
              href="javascript:;"
              role="tab"
              [attr.aria-selected]="selectedTab == 'results' ? 'true' : 'false'"
            >
              {{ 'competitionModule.results' | translate }}
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              (click)="selectedTab = 'tables'"
              (keyup.enter)="selectedTab = 'tables'"
              [ngClass]="{
                active: selectedTab == 'tables'
              }"
              href="javascript:;"
              role="tab"
              [attr.aria-selected]="selectedTab == 'tables' ? 'true' : 'false'"
            >
              {{ 'competitionModule.tables' | translate }}
            </a>
          </li>
        </ul>
      </nav>

      <!-- End Nav -->

      <matches-tab
        [hidden]="selectedTab !== 'matches'"
        [competitionId]="competitionId$ | async"
        [filteredTeams]="selectedCompetitionTeamIds"
      ></matches-tab>

      <results-tab
        [hidden]="selectedTab !== 'results'"
        [competitionId]="competitionId$ | async"
        [filteredTeams]="selectedCompetitionTeamIds"
      ></results-tab>
      <tables-tab
        *ngIf="selectedTab == 'tables'"
        [competitionId]="competitionId$ | async"
        [filteredTeams]="selectedCompetitionTeamIds"
      ></tables-tab>
    </div>
    <!-- End Body -->
  </section>

  <!-- End Row -->
</div>
